import React, { useEffect } from "react";
import LottieAnimation from "src/components/LottieAnimation";
import useUrbinRequest from "src/hooks/useUrbinRequest";
import animationData from "src/lotties/arkadu_city.json";
import { useSelector } from "src/store";

const UrbinLayout = ({ children }) => {
  const { urbanProducts, urbanRequestCategories } = useSelector(
    (state) => state.urbin
  );

  const { currentCustomer } = useSelector((state) => state.customers);
  const { adminMode } = useSelector((state) => state.settings);

  const { getUrbinConfiguration } = useUrbinRequest();

  useEffect(() => {
    if ((!urbanRequestCategories || urbanRequestCategories.length === 0) && currentCustomer) {
      getUrbinConfiguration();
    }
  }, [urbanRequestCategories, currentCustomer]);
  if (!urbanRequestCategories ) {
    return <LottieAnimation animationData={animationData} size={"400px;"} />;
  }
  return <>{children}</>;
};

export default UrbinLayout;
